class MarketSearch extends window.BAO.CustomElement {
  setupListeners () {
    super.setupListeners()

    this.els.input.element.addEventListener('input', e => {
      this.searchVal = e.target.value
    })
  }

  resetCountries () {
    this.els.item.elements.forEach(element => {
      element.ariaHidden = false
    })
  }

  countryMatch (country, val) {
    const matchingTitle = country.dataset.title.toLowerCase().includes(val)
    const matchingCountryCode = country.dataset.code.toLowerCase().includes(val)
    const matchingCurrencyCode = country.dataset.currency
      .toLowerCase()
      .includes(val)

    if (matchingTitle || matchingCountryCode || matchingCurrencyCode) {
      return true
    } else {
      return false
    }
  }

  get searchVal () {
    return this._searchVal
  }

  set searchVal (val) {
    const valDown = val.toLowerCase()
    if (val.length > 0) {
      this.els.item.elements.forEach(element => {
        element.ariaHidden = !this.countryMatch(element, valDown)
      })
    } else {
      this.resetCountries()
    }
  }
}

customElements.define('market-search', MarketSearch)
